import { enqueueSnackbar } from "notistack";


export const innerStateOfConfigIsNotSatNotify = () => {
  enqueueSnackbar("Something went wrong while saving config", { variant: "error" });
  console.error("Something went wrong while saving config, inner state of config isn't sat");
}
